var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    "p-4",
    "rounded-2xl bg-white dark:bg-gray-900 shadow-md",
    _vm.$listeners.click && 'cursor-pointer hover:shadow-lg transition ease-in-out duration-300 hover:scale-105 transform'
    ],on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.$slots.header)?_c('div',[_vm._t("header")],2):_vm._e(),_c('div',[(!_vm.loading)?_vm._t("default"):_c('a-skeleton',{attrs:{"height":"60px","count":2}})],2),(_vm.$slots.footer)?_c('div',{class:["space-x-2 inline-flex"]},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }